// I18Translation.tsx
import CustomButton from "@components/common/Button";
import { ensureReady } from "@/i18n/i18nLoader";
import { setLocalLanguage } from "@lib/storeManager";
import { GlobalOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const I18Translation = () => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const nsList = useMemo(() => ["common"], []);

  const changeLanguage = async (lng: string) => {
    if (loading || lng === i18n.language) {
      return;
    }
    setLoading(true);
    try {
      await ensureReady({ lng, nsList });
      await i18n.changeLanguage(lng);
      setLocalLanguage(lng);
    } catch (error) {
      console.error("Failed to change language:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: "en",
            label: "English",
            onClick: () => changeLanguage("en"),
            disabled: loading || i18n.language === "en",
          },
          {
            key: "hi",
            label: "हिन्दी",
            onClick: () => changeLanguage("hi"),
            disabled: loading || i18n.language === "hi",
          },
        ],
      }}
    >
      <CustomButton icon={<GlobalOutlined />} />
    </Dropdown>
  );
};

export default I18Translation;
